<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'corporative'">
  <app-contact-info/>
</app-user-dashboard>
